import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [``],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public data: any = {
        email: '',
        password: ''
    };

    public testAccounts: any[] = [];
    public colors: string[] = ['#2563eb', '#16a34a', '#db2777', '#ea580c'];

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) return location.href = "/";
        await this.loadTestAccounts();
    }

    public async loadTestAccounts() {
        const { code, data } = await wiz.call("test_accounts");
        if (code === 200) {
            this.testAccounts = data.accounts || [];
        }
        await this.service.render();
    }

    public accountColor(account: any) {
        const index = this.testAccounts.findIndex(item => item.email === account.email);
        return this.colors[Math.max(index, 0) % this.colors.length];
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.data));
        if (!user.email) {
            await this.alert("이메일을 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        let { code, data } = await wiz.call("login", user);

        if (code == 200) {
            location.href = "/";
            await this.service.render();
        } else {
            await this.alert(data.message || "로그인에 실패했습니다.", 'error');
        }
    }

    public async quickLogin(account: any) {
        const { code, data } = await wiz.call("quick_login", { email: account.email });
        if (code === 200) {
            location.href = "/";
            return;
        }
        await this.alert(data.message || "자동 로그인에 실패했습니다.");
    }
}

export default PageAccessComponent;